import { memo } from 'react';

import { FavoriteButton } from '@/components/FavoriteButton';
import type { MenuItem } from '@/consts/navigation';
import { useActiveRoute } from '@/features/navigation/hooks/useActiveRoute';
import { cn } from '@/utils/cn';

import { NavLink } from './NavLink';

interface NavMenuItemRowProps {
  childItem: MenuItem;
  isPopover: boolean;
  isUtilitySection?: boolean;
}

export const NavMenuItemRow = memo<NavMenuItemRowProps>(function NavMenuItemRow({
  childItem,
  isPopover,
  isUtilitySection
}) {
  const { isActive } = useActiveRoute(childItem.to);
  const isEmptyState = !childItem.to;

  return (
    <li key={childItem.text} role="none">
      <div
        className={cn(
          'relative flex items-center justify-between rounded-md transition-colors',
          isPopover &&
            cn(
              'text-nav-item hover:text-typography min-h-10 gap-2.5 px-4',
              isActive ? 'bg-primary/10 text-primary-100' : isEmptyState ? '' : 'hover:bg-secondary-400/30'
            )
        )}
        role="menuitem"
      >
        <NavLink
          to={childItem.to ?? undefined}
          text={childItem.text}
          isUtilitySection={isUtilitySection}
          className={cn(
            'text-left',
            isPopover && 'flex-1 overflow-hidden pl-0 text-[13px] text-ellipsis whitespace-nowrap',
            isEmptyState && 'text-typography-100/50 cursor-default italic'
          )}
        />

        {!isEmptyState && (
          <FavoriteButton code={childItem.code} itemText={childItem.text} isActive={isActive} isPopover={isPopover} />
        )}
      </div>
    </li>
  );
});
